<template>
  <div>
    <!-- TrustBox widget - Micro Review Count -->
    <div class="trustpilot-widget" data-locale="en-GB" data-template-id="5419b6a8b0d04a076446a9ad" data-businessunit-id="61b64eee8dd10a4cbfcc34a9" data-style-height="24px" data-style-width="100%" data-theme="light" data-min-review-count="10">
      <a href="https://uk.trustpilot.com/review/jgestates.co.uk" target="_blank" rel="noopener">Trustpilot</a>
    </div>
    <!-- End TrustBox widget -->
  </div>
</template>

<script>
export default {
  mounted() {
      let trustPilotScript = document.createElement('script')
      trustPilotScript.setAttribute('src', 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js')
      document.head.appendChild(trustPilotScript)
  },
}
</script>

<style>

</style>